import classnames from 'classnames'
import { useDispatch, useSelector } from 'react-redux'
import { useEffect, useState } from 'react'
import { NavLink, Outlet, useNavigate } from 'react-router-dom'
import { selectIsOnboardingEnabled } from '../../../reducers/coachOnboardingReducer'
import { getUnreadNotifications } from '../../../actions/notificationActions'
import { getCoachOnboardingSteps } from '../../../actions/coachOnboardingActions'
import { setCurrentTab, showNavBar, showSideBar } from '../../../actions/commonActions'
import { COMMON_ERRORS } from '../../../misc/Constants'
import { Nav, Navbar, NavItem } from 'reactstrap'
import { toast } from 'react-toastify'
import PageHeader from '../../common/PageHeader/PageHeader'
import DashboardHeaderNotifications from './DashboardHeaderNotifications'
import EventInProgressAlert from '../../events/EventInProgressAlert'
import CoachOnboardingDismissModal from './coachOnboarding/CoachOnboardingDismissModal'
import CoachWelcomeModal from './coachOnboarding/CoachWelcomeModal'
import Loader from '../../common/loader/legacy-loaders/Op36Loader-web'

import classes from './CoachDashboard.module.scss'

const tabsData = [
  { name: 'Home', route: 'home' },
  { name: 'Coaching', route: 'coaching' },
  { name: 'Business', route: 'business' },
]

const CoachDashboard = () => {
  const user = useSelector(state => state.user.current_user)
  const isCoachOnboardingEnabled = useSelector(selectIsOnboardingEnabled)
  const navigate = useNavigate()
  const dispatch = useDispatch()

  const [isLoading, setIsLoading] = useState(true)
  const [showEventInProgressAlert, setShowEventInProgressAlert] = useState(true)
  const community = user.communities[0]

  useEffect(() => {
    dispatch(setCurrentTab('Dashboard'))
    dispatch(showSideBar(true))
    dispatch(showNavBar(true))

    Promise.all([
      dispatch(getUnreadNotifications(user.id)),
      user.user_settings.coach_onboarding_status === 'started'
        ? dispatch(getCoachOnboardingSteps(user.id))
          .unwrap()
        : Promise.resolve(),
    ])
      .then(() => {
        setIsLoading(false)
      })
      .catch(() => {
        toast.error(COMMON_ERRORS[500])
      })
  }, [dispatch, user.id, user.user_settings.coach_onboarding_status])

  if (isLoading) {
    return (
      <Loader message='Loading Dashboard...' />
    )
  }

  return (
    <div className={classnames('d-flex flex-column', classes.coachDashboardPage)}>
      <PageHeader
        title={`${community.name} Dashboard`}
        iconUrl={community.photo?.file_url}
        titleUrl={`/landing/${community.id}`}
        actionComponent={<DashboardHeaderNotifications />}
      />
      <header className='d-flex flex-column'>
        {community.ongoing_events_count > 0 && showEventInProgressAlert && (
          <EventInProgressAlert
            scoresPassedDue={true}
            onClick={() => navigate('/events')}
            onClose={() => setShowEventInProgressAlert(false)}
          />
        )}
        <Navbar className={classnames(classes.navbar, { [classes.hidden]: isCoachOnboardingEnabled })}>
          <Nav className={classes.nav} tabs>
            {tabsData.map((item, index) => (
              <NavItem key={index} className={classes.navItem}>
                <NavLink
                  to={item.route}
                  className={({ isActive }) => classnames(classes.navLink, { [classes.active]: isActive })}
                >
                  {item.name}
                </NavLink>
              </NavItem>
            ))}
          </Nav>
        </Navbar>
      </header>
      <main className={classes.main}>
        <Outlet />
      </main>
      {isCoachOnboardingEnabled && <CoachOnboardingDismissModal />}
      {isCoachOnboardingEnabled && <CoachWelcomeModal />}
    </div>
  )
}

export default CoachDashboard
